export var AiTaggingStep;
(function (AiTaggingStep) {
    AiTaggingStep["SELECT_FIELD"] = "SELECT_FIELD";
    AiTaggingStep["TAGGING_SETTING"] = "TAGGING_SETTING";
    AiTaggingStep["TAGGING_PROCESS"] = "TAGGING_PROCESS";
    AiTaggingStep["TAGGING_RESULT"] = "TAGGING_RESULT";
})(AiTaggingStep || (AiTaggingStep = {}));
export var AiTaggingType;
(function (AiTaggingType) {
    AiTaggingType["MULTI"] = "multi";
    AiTaggingType["SINGLE"] = "single";
})(AiTaggingType || (AiTaggingType = {}));
export var AiThreshold;
(function (AiThreshold) {
    AiThreshold[AiThreshold["LOW"] = 0] = "LOW";
    AiThreshold[AiThreshold["MEDIUM"] = 50] = "MEDIUM";
    AiThreshold[AiThreshold["HIGH"] = 100] = "HIGH";
})(AiThreshold || (AiThreshold = {}));
export var AiThresholdMarks;
(function (AiThresholdMarks) {
    AiThresholdMarks["LOW"] = "Low";
    AiThresholdMarks["MEDIUM"] = "Medium";
    AiThresholdMarks["HIGH"] = "High";
})(AiThresholdMarks || (AiThresholdMarks = {}));
export var SmartLabelStatus;
(function (SmartLabelStatus) {
    SmartLabelStatus["IN_PREPARE_DATA"] = "IN_PREPARE_DATA";
    SmartLabelStatus["READY_PREPARE_DATA"] = "READY_PREPARE_DATA";
    SmartLabelStatus["IN_TRAINING"] = "IN_TRAINING";
    SmartLabelStatus["READY_TO_LABEL"] = "READY_TO_LABEL";
    SmartLabelStatus["IN_LABEL"] = "IN_LABEL";
    SmartLabelStatus["IN_SAVING_RESULT"] = "IN_SAVING_RESULT";
    SmartLabelStatus["FINISH_LABEL"] = "FINISH_LABEL";
    SmartLabelStatus["LABEL_CANCELING"] = "LABEL_CANCELING";
    SmartLabelStatus["LABEL_CANCELED"] = "LABEL_CANCELED";
})(SmartLabelStatus || (SmartLabelStatus = {}));
export var LabelTaskStatus;
(function (LabelTaskStatus) {
    LabelTaskStatus["RUNNING"] = "RUNNING";
    LabelTaskStatus["CANCELING"] = "CANCELING";
    LabelTaskStatus["IDLE"] = "IDLE";
})(LabelTaskStatus || (LabelTaskStatus = {}));
export var AiTaggingStatus;
(function (AiTaggingStatus) {
    AiTaggingStatus["LOADING"] = "LOADING";
    AiTaggingStatus["FINISH"] = "FINISH";
    AiTaggingStatus["FAILED"] = "FAILED";
})(AiTaggingStatus || (AiTaggingStatus = {}));
export var DataScopeField;
(function (DataScopeField) {
    DataScopeField["TTL"] = "title";
    DataScopeField["ABST"] = "abst";
    DataScopeField["CLMS"] = "claim";
    DataScopeField["DESC"] = "desc";
    DataScopeField["TECHNICAL_PROBLEM"] = "techprob";
    DataScopeField["EFFICIENCY_SENTENCE"] = "techeffi";
    DataScopeField["TECHNICAL_TITLE"] = "aititle";
    DataScopeField["PATENT_INNO_SUMMARY"] = "solution";
    DataScopeField["ABST_IMAGE"] = "abst_image";
})(DataScopeField || (DataScopeField = {}));
export var AiModel;
(function (AiModel) {
    AiModel["PATSNAP_ML"] = "ml";
    AiModel["PATSNAP_GPT"] = "llm";
})(AiModel || (AiModel = {}));
